import {useState, useEffect, useRef} from "react";
import {Button, LazyLoad, RiveLoad, Slide, Slider, Top} from "parts";
import {Plan, TimerPanel, PaymentWindow} from "parts/paywall";
import {setPrice, setTrack, useEmail, usePaywall} from "utils";
import {Trans, useTranslation} from "react-i18next";
import {BookEnum} from "_business";
import i18n from "i18next";
import {BookComments} from "parts/book";
import {useSearchParams} from "react-router-dom";

export function PaywallBook({price, onClick, onSkip, message}) {
  const
    {uid} = usePaywall({force: !!price}),
    {
      handleSubmit,
      isLoading
    } = useEmail()

  const
    keyPrefix = 'paywall-book',
    {t} = useTranslation('common', {keyPrefix}),
    {t: t0} = useTranslation('common'),
    [searchParams] = useSearchParams()

  const
    [active, setActive] = useState(),
    [timing] = useState(15 * 60),
    [payment, setPayment] = useState(false),
    userCreatedUid = useRef(null),

    [blobUrl, setBlobUrl] = useState(null),

    // A81 = getExperiment('A81'),
    [paymentType] = useState(null)
    // [paymentType] = useState(A81.value === 'B' ? 'credit' : null)

  // useLayoutEffect(() => {
  //   if (searchParams.get('source') === 'app' && searchParams.get('email')) {
  //     setEmail()
  //     handleSubmit(null, {source: 'app'})
  //   }
  // }, [])

  useEffect(() => {
    if (active && !price) {
      setPrice(active)
      // setTrack('pricing_option_selected', {plan: active.period})
    }

    let canceled = false

    fetch('/static/rive/book-charisma.riv', {
      cache: 'force-cache'
    })
      .then(r => r.blob())
      .then(blob => {
        if (!canceled)
          setBlobUrl(URL.createObjectURL(blob))
      })

    return () => {
      canceled = true
    }
  }, [active])

  const
    handleGetMyPlan = (index) => {
      if (onClick) {
        // setTrack(`book3_cta_${index === 1 ? 'top' : 'bottom'}`)
        onClick(index === 1 ? 'top' : 'bottom')
      } else {
        setTrack(`book_paywall_btn_${index}_click`)

        if (!userCreatedUid.current && searchParams.get('source') === 'app' && searchParams.get('email')) {
          handleSubmit(
            null,
            {source: 'app', email: searchParams.get('email')},
            (newUid) => {
              userCreatedUid.current = newUid
              setPayment(true)
            }
          )
        } else
          setPayment(true)
      }
    }

  const handleItemContent = item => {
    const itemBook = item[BookEnum.charisma]

    return (
      <>
        <div className={'w-100 text-start'}>
          <strong>{itemBook.name[i18n.resolvedLanguage]}</strong>
          <p><s className={'note lg'}>
            {t('plan.regularPrice')} {item.currency} {itemBook.full_price}
          </s></p>
        </div>
        <div className={'nowrap'}>
          <sup>{item.currencySymbol}</sup>
          <big>{Math.trunc(itemBook.price)}</big>
          <div>
            <em>{Math.round(itemBook.price % 1 * 100)}</em>
          </div>
        </div>
      </>
    )
  }

  const
    // guide = [
    //   {
    //     "icon": require('assets/img/paywall-book/guide/person_crown.svg').default,
    //     "name": "Leaders & speakers"
    //   },
    //   {
    //     "icon": require('assets/img/paywall-book/guide/networking.svg').default,
    //     "name": "Job-seekers & networkers"
    //   },
    //   {
    //     "icon": require('assets/img/paywall-book/guide/lamp.svg').default,
    //     "name": "Creatives & performers"
    //   },
    //   {
    //     "icon": require('assets/img/paywall-book/guide/graph.svg').default,
    //     "name": "Introverts & self-improvers"
    //   },
    // ],
    scenarios = ['First dates', 'Networking', 'Business meetings', 'Career', 'Public speaking', 'Social introductions']

  return (
    <>
<style>{`
  .built-block { padding: 14px 0; border-radius: var(--radius); font-weight: bold; text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25) }
  .built-block i { font-size: 20px }
`}</style>

      {
        !onClick &&
        <TimerPanel count={timing} keyPrefix={keyPrefix}/>
      }

      <div className={'wrap renewal'}>
        <Top>
          {message && <div id="payment-message">{message}</div>}

          <h1 className={'text-center pre-line w-100'}>
            <Trans i18nKey="h1" t={t}>
              Make an unforgettable
              <span className={'marked'}>first impression!</span>
            </Trans>
          </h1>

          <BookInfo t={t}/>

          <Plan path={'discount'} book={BookEnum.charisma} discount={true} strict={true} price={price}
                onChange={item => setActive(item)}
                itemContent={handleItemContent}
          >
            <Button onClick={() => handleGetMyPlan(1)}>
              {t('plan.btn')}
              {isLoading && <span className="spinner ml-2"></span>}
            </Button>
            {
              onSkip &&
              <Button variant={''} onClick={onSkip}>{t0('next')}</Button>
            }
          </Plan>

          <div className={'block text-center'}>
            <h2 className={'h1'} style={{marginBottom: 4}}>This guide is for:</h2>
            <p className={'mb-4'}>
              Anyone who wants to feel <span className={'marked'}>seen, heard, and remembered</span>
            </p>

            <div className={'mx-auto'} style={{aspectRatio: 310 / 270, maxWidth: 310}}>
            {
              blobUrl &&
              <RiveLoad width={310} height={270} toLoad={false}
                        onInput={m => m.fire()}
                        inputName={'Trigger'}
                        src={blobUrl} stateMachines={'State Machine 1'} artboard={'Guide'}
              />
            }
            </div>

{/*            <div className={'items center gap-2 mb-2'}>
              {
                guide.map(({icon, name}, i) =>
                  <p key={i} className={'panel rounded-3 gap-2 row center w-auto fw-bold'}
                     style={{
                       border: '4px solid var(--bg-90)',
                       backgroundColor: 'var(--bg-60)',
                       padding: '12px 16px',
                       transform: `rotate(${i % 2 ? 5 : -5}deg)`,
                       zIndex: i === 1 ? 1 : 0,
                     }}
                  >
                    <img width={20} height={20} src={icon} alt={icon} style={{order: i % 2}}/>
                    {name}
                  </p>
                )
              }
            </div>*/}
          </div>

          <h2 className={'h1'}>Unleash Your Natural Presence</h2>
          <div className={'stack gap-5'}>
            <div className={'row md mb-2'}>
              <img width={120} height={186} src={'/static/img/paywall-book/1.png'} loading={'lazy'}
                   alt={'Instant Impact Through Charisma'}/>
              <div>
                <h3 style={{marginBottom: 4}}>Instant Impact Through Charisma</h3>
                <p className={'notice bold-light'}>Learn how to master the <b>7 key nonverbal cues</b> that shape first
                  impressions — whether
                  in person or online — to instantly build trust, respect, and connection.</p>
              </div>
            </div>

            <div className={'row md mb-2'}>
              <div>
                <h3 style={{marginBottom: 4}}>Practical and Time-Efficient — Just 3 Minutes a Day</h3>
                <p className={'notice bold-light'}>
                  Each technique is designed for <b>quick, daily practice</b>, making it easy
                  to develop lasting charisma even with a busy schedule.
                </p>
              </div>
              <img width={120} height={172} src={'/static/img/paywall-book/2.png'} loading={'lazy'}
                   alt={'Practical and Time-Efficient — Just 3 Minutes a Day'}/>
            </div>

            <div className={'row md mb-2'}>
              <img width={120} height={214} src={'/static/img/paywall-book/3.png'} loading={'lazy'}
                   alt={'Your Personal Voice Coach'}/>
              <div>
                <h3 style={{marginBottom: 4}}>
                  Enhanced with Vocal Image — Your Personal Voice Coach
                </h3>
                <p className={'notice bold-light'}>The book pairs seamlessly with the <b>Vocal Image app</b>, offering
                  interactive voice training, warm-ups, and diagnostics to bring the lessons to life and amplify your
                  presence.</p>
              </div>
            </div>
          </div>

          <BookComments/>

          <div className={'block stack gap-5 text-center'}>
            <div>
              <h3 className={'h2 pre-line'} style={{marginBottom: 4}}>
                Built with Psychology,<br/>Backed by Neuroscience
              </h3>
              <p className={'notice'}>
                From the amygdala’s snap-judgment reactions to the voice’s influence on oxytocin and trust.
              </p>
            </div>

            <div className={'w-100'}>
              <div className={'mx-auto'} style={{aspectRatio: 270 / 250, maxWidth: 270}}>
                {
                  blobUrl &&
                  <LazyLoad offset={0}>
                    <RiveLoad width={270} height={250} toLoad={false}
                              onInput={m => m.fire()}
                              inputName={'Trigger'}
                              src={blobUrl} stateMachines={'State Machine 1'} artboard={'Psychology'}
                    />
                  </LazyLoad>
                }
              </div>
            </div>

{/*            <div className={'items center'} style={{gap: 4}}>
              <div className={'row sm center built-block'}
                   style={{
                     width: 150,
                     background: 'radial-gradient(50% 50% at 50% 50%, rgba(40, 57, 206, 0.64) 0%, rgba(40, 57, 206, 0.48) 59.13%, rgba(40, 57, 206, 0.24) 100%), linear-gradient(0deg, #5667F9, #5667F9)'
                   }}
              ><i>🧠</i>Science
              </div>

              <div className={'row sm center built-block'}
                   style={{
                     width: 210,
                     background: 'radial-gradient(50% 50% at 50% 50%, rgba(240, 128, 8, 0.8) 0%, rgba(240, 128, 8, 0.48) 59.13%, rgba(240, 128, 8, 0.16) 100%), linear-gradient(0deg, #FDC639, #FDC639)'
                   }}
              ><i>📚</i>Strategy
              </div>

              <div className={'row sm center built-block'}
                   style={{
                     width: 270,
                     background: 'radial-gradient(50% 50% at 50% 50%, rgba(86, 175, 16, 0.8) 0%, rgba(86, 175, 16, 0.48) 59.13%, rgba(86, 175, 16, 0.16) 100%), linear-gradient(0deg, #9BE760, #9BE760), radial-gradient(50% 50% at 50% 50%, rgba(40, 57, 206, 0.64) 0%, rgba(40, 57, 206, 0.48) 59.13%, rgba(40, 57, 206, 0.24) 100%), linear-gradient(0deg, #5667F9, #5667F9)'
                   }}
              ><i>🕒</i>Daily practice
              </div>
            </div>

            <div className={'panel row gap-2 w-auto'} style={{
              padding: '8px 12px',
              borderRadius: 28,
              fontSize: 12,
              lineHeight: 1,
              backgroundColor: 'rgba(149, 177, 255, 0.2)'
            }}>
              <img src={require('assets/img/icon/record_done.svg').default} alt="" width={16} height={16}/>
              All you need — 3 minutes a day
            </div>*/}

            <hr/>

            <div className={'row gap-2'}>
              <img src={'/static/img/survey/graph/hbr_logo.png'} loading={'lazy'} alt="" width={116} height={50}/>
              <p className={'notice text-start bold-light'} style={{fontSize: 8, lineHeight: '10px'}}>
                The Harvard Business Review has highlighted the significance of vocal quality in professional
                settings. <b>A strong, clear, and expressive voice is considered an essential component of effective
                communication, influencing how one is perceived by colleagues and superiors.</b>
              </p>
            </div>
          </div>

          <div className={'text-center'}>
            <h3 className={'h1'} style={{marginBottom: 4}}>
              🎯 Charisma in Action:<br/>Job Interview Example
            </h3>
            <p className={'notice md'}>A warm, confident presence can spark connection even before words are
              exchanged.</p>
          </div>

          <Slider size={'lg'}>
            {Array.from(Array(2), (e, i) =>
              <Slide key={i} index={i}>
                <img src={`/static/img/paywall-book/book-${i + 1}.png`} loading={'lazy'} alt={`book ${i + 1}`} width={350}
                     height={305} className={'mw-100 w-100'}/>
              </Slide>
            )}
          </Slider>

          <h3 className={'h2 text-center'}>More real-world Charisma scenarios inside e-Book:</h3>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', columnGap: 12, rowGap: 20}}>
            {scenarios.map((item, i) =>
              <p key={item} className={'row gap-3'}>
                <img src={`/static/img/paywall-book/scenarios/${i + 1}.png`} loading={'lazy'} alt={item} width={60} height={42}/>
                <span className={'notice md'}>{item}</span>
              </p>
            )}
          </div>

          <div className={'w-100 text-center'}>
            <h3 className={'h1'} style={{marginBottom: 4}}>
              Now – Only <span className={'gold'}>{active?.currencySymbol}{active?.[BookEnum.charisma]?.price}</span>
            </h3>
            <p className={'fw-bold'}>✨ LAUNCH SPECIAL. LIMITED TIME ONLY ✨</p>
          </div>
          <img className={'w-100 mw-100'} src={'/static/img/paywall-book/picture.png'} loading={'lazy'}
               alt={'LAUNCH SPECIAL. LIMITED TIME ONLY'} width={350} height={175}/>

          <BookInfo t={t} bottom={true}/>

          {
            active &&
            <Plan path={'discount'} book={BookEnum.charisma} discount={true} strict={true} price={price || active}
                  onChange={item => setActive(item)}
                  itemContent={handleItemContent}
            >
              <Button onClick={() => handleGetMyPlan(2)}>
                {t('plan.btn2')}
                {isLoading && <span className="spinner ml-2"></span>}
              </Button>
              {
                onSkip &&
                <Button variant={''} onClick={onSkip}>{t0('next')}</Button>
              }
            </Plan>
          }
        </Top>
      </div>

      {
        payment &&
        <PaymentWindow data={active} book={BookEnum.charisma} paymentType={paymentType}
                       nextUrl={`${process.env.REACT_APP_WEB_LINK}book-download/${userCreatedUid.current || uid}?type=${BookEnum.charisma}`}
                       onClose={() => setPayment(false)}
        >
          <></>
        </PaymentWindow>
      }
    </>
  )
}

function BookInfo({t, bottom = false}) {
  return (
    <div className={'block text-center stack'}
         style={{
           paddingBottom: bottom ? 0 : 20,
           background: 'radial-gradient(50% 50% at 50% 50%, rgba(255, 57, 255, 0.32) 0%, rgba(255, 57, 255, 0) 100%), linear-gradient(0deg, #121620, #121620)'
         }}
    >
      <img src={'/static/img/paywall-book/book_info.png'} loading={'lazy'} alt="book" width={310} height={160}
           className={'mw-100 mx-auto'} style={bottom ? {order: 1} : {}}/>

      <h2 style={{marginBottom: 4}}>{t('h2')}</h2>
      <p className={'notice md'}>{t('note')}</p>
    </div>
  )
}